import { render, staticRenderFns } from "./RateOption.vue?vue&type=template&id=67a84020&scoped=true"
import script from "./RateOption.vue?vue&type=script&lang=js"
export * from "./RateOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a84020",
  null
  
)

export default component.exports